import { StyleSheet, Font } from "@react-pdf/renderer";

////////////////Register fonts
Font.register({
  family: "Rubik",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4i1UE80V4bVkA.ttf",
    },
    {
      src: "https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-NYi1UE80V4bVkA.ttf",
      fontWeight: 600,
    },
  ],
});

Font.register({
  family: "Roboto Condensed",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyUyovBJ731BKMSK.ttf",
      fontWeight: 200,
    },
    {
      src: "https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyWyovBJ731BKMSK.ttf",
      fontWeight: 400,
    },
    {
      src: "https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyVVpfBJ731BKMSK.ttf",
      fontWeight: 600,
    },
    {
      src: "https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyVVpfBJ731BKMSK.ttf",
      fontWeight: 700,
    },
    {
      src: "https://fonts.gstatic.com/s/robotocondensed/v27/ieVW2ZhZI2eCN5jzbjEETS9weq8-19ehAyvMum7nfDB64ZgK5XljLdSK37o.ttf",
      fontWeight: 200,
      fontStyle: "italic",
    },
  ],
});

////////////////CSS styling
export const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto Condensed",
    fontSize: 11,
    padding: 20,
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },

  col: {
    width: "100%",
    textAlign: "left",
    marginRight: 5,
  },

  col_3: {
    width: "30%",
    textAlign: "left",
    marginRight: 5,
  },

  col_7: {
    width: "70%",
    textAlign: "left",
    marginRight: 5,
  },

  fs_1: {
    fontSize: 20,
  },

  fs_2: {
    fontSize: 14,
  },

  fs_3: {
    fontSize: 11,
  },

  fs_4: {
    fontSize: 10,
  },

  fw_200: {
    fontWeight: 200,
  },

  fw_400: {
    fontWeight: 400,
  },

  fw_600: {
    fontWeight: 600,
  },

  fw_700: {
    fontWeight: 700,
  },
});
